import { c as _c } from "react/compiler-runtime";
import Reviews from '@/components/modules/Reviews';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Section } from '@winelidays/wld-tsx-2/modules';
import RatingsBanner from './RatingsBanner';
const ReviewsSection = (t0) => {
    const $ = _c(19);
    const { reducedSectionWidth, entity } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== translate) {
        t1 = translate("review.reviews.section_title");
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const sectionTitle = t1;
    let t2;
    if ($[2] !== translate) {
        t2 = translate("review.reviews.tab_label");
        $[2] = translate;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const navLabel = t2;
    let t3;
    if ($[4] !== sectionTitle) {
        t3 = <h2 className="text-title mb-4">{sectionTitle}</h2>;
        $[4] = sectionTitle;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    let t4;
    if ($[6] !== entity || $[7] !== reducedSectionWidth) {
        t4 = <RatingsBanner entity={entity} reducedSectionWidth={reducedSectionWidth}/>;
        $[6] = entity;
        $[7] = reducedSectionWidth;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    let t5;
    if ($[9] !== entity) {
        t5 = <Reviews entity={entity} className="flex flex-col pb-10"/>;
        $[9] = entity;
        $[10] = t5;
    }
    else {
        t5 = $[10];
    }
    let t6;
    if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
        t6 = <>{t3}{t4}{t5}</>;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    }
    else {
        t6 = $[14];
    }
    let t7;
    if ($[15] !== navLabel || $[16] !== reducedSectionWidth || $[17] !== t6) {
        t7 = <Section id="reviews" reducedSectionWidth={reducedSectionWidth} className="py-8 pb-0 md:pb-4" data-nav-label={navLabel}>{t6}
    </Section>;
        $[15] = navLabel;
        $[16] = reducedSectionWidth;
        $[17] = t6;
        $[18] = t7;
    }
    else {
        t7 = $[18];
    }
    return t7;
};
export default ReviewsSection;
